import { render } from "./TlbsInformationComponent.vue?vue&type=template&id=2052ac05&ts=true"
import script from "./TlbsInformationComponent.vue?vue&type=script&lang=ts"
export * from "./TlbsInformationComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__